import React, { useContext } from "react";
import { ProtectedLayout } from "./ProtectedLayout";
import { Navigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { ROLES } from "../../utils/roles";

interface Props {
  children: JSX.Element | JSX.Element[];
  permissions?: null | "CLIENT" | "ADMIN" | "USER" | "DEMO";
}
export const ProtectedRoute = ({ permissions, children }: Props) => {
  const { validateToken, onLogout, role: userRole } = useContext(AuthContext);

  if (!validateToken()) {
    onLogout();
    return <Navigate to="/login" replace />;
  }

  // if (userRole !== ROLES.ADMIN && !permissions?.includes(userRole as any)) {
  //   onLogout();
  //   return <Navigate to="/login" replace />;
  // }

  return <ProtectedLayout>{children}</ProtectedLayout>;
};
